export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_763_CLOSE': 'Close'
};
